import { CAT_WEBSITE_SERVICES } from 'App/utils/Collections';

export default {
  category: CAT_WEBSITE_SERVICES,
  filters: [],
  searchBarProp: 'name',
};
